module.exports = __webpack_public_path__ + "img/20200614_111131.8b977af7.jpg";